import React, {Component} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {bindActionCreators} from "redux";
import RefillCard from './RefillCard';
import './ActiveRefills.scss';

export default class ActiveRefills extends Component {
  render() {
    const { refills, currentIndex , actions} = this.props;
    return (<div>
      {refills.length > 0 ? refills.map((refill, index) => <RefillCard key={refill.detail.id} refillDetails={refill} index={index} actions={actions} currentIndex={currentIndex} />) : <div>No active refills found.</div>}
    </div>);
  }
}

